export default "__VITE_ASSET__DAN03Kzc__"